import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-17oyluh-0"
})(["display:block;padding:3px 0;cursor:pointer;font-size:0.83rem;"]);
export var StyledResult = styled.div.withConfig({
  displayName: "partials__StyledResult",
  componentId: "sc-17oyluh-1"
})(["display:flex;justify-content:space-between;border-bottom:", ";margin-bottom:16px;svg{margin-right:8px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiLL;
});
export var ProductName = styled.div.withConfig({
  displayName: "partials__ProductName",
  componentId: "sc-17oyluh-2"
})(["color:", ";", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiDD;
}, getFont(1));
export var ManagementCompany = styled.div.withConfig({
  displayName: "partials__ManagementCompany",
  componentId: "sc-17oyluh-3"
})(["color:", ";", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.uiDD;
}, getFont(0, 'compact'));